import { handleBridgeSessionRequestResponse } from '../../agents/acp/from-bridge/handle-bridge-session-request-response.js';
import type { BridgeMessageHandler } from '../message-router.js';

export const handleSessionRequestResponseMessage: BridgeMessageHandler<'cursor_request_response'> = (msg, deps) => {
  handleBridgeSessionRequestResponse(msg, deps);
};
